<!-- @format -->

@if (visible) {
  <div class="cookie-consent text-body-12">
    <p class="cookie-consent__text">
      Мы используем файлы cookie для корректной работы платформы и улучшения сервиса.
    </p>

    <div class="cookie-consent__controls">
      <div class="cookie-consent__buttons">
        <app-button size="big" customTypographyClass="text-body-12" (click)="confirm()">
          Согласен
        </app-button>
        <app-button
          size="big"
          appearance="outline"
          customTypographyClass="text-body-12"
          (click)="decline()"
        >
          Не согласен
        </app-button>
      </div>
    </div>
  </div>
}
